import { computed, readonly, ref } from 'vue';

export enum ScheduleState {
  INITIALIZING = 'INITIALIZING',
  LOADING = 'LOADING',
  LOADED = 'LOADED',
}

const scheduleState = ref<ScheduleState>(ScheduleState.INITIALIZING);

/**
 * Composable for managing schedule state
 * This provides a global state that can be used across the application
 */
export function useScheduleState() {
  const isLoaded = computed(() => scheduleState.value === ScheduleState.LOADED);
  const isLoading = computed(() => scheduleState.value === ScheduleState.LOADING);
  const isInitializing = computed(() => scheduleState.value === ScheduleState.INITIALIZING);

  const setInitializing = (): void => {
    scheduleState.value = ScheduleState.INITIALIZING;
  };

  const setLoading = (): void => {
    scheduleState.value = ScheduleState.LOADING;
  };

  const setLoaded = (): void => {
    scheduleState.value = ScheduleState.LOADED;
  };

  return {
    isInitializing,
    isLoaded,
    isLoading,
    state: readonly(scheduleState),
    setInitializing,
    setLoaded,
    setLoading,
  };
}
